/**
 * Thin re-export — consolidated onto `@/lib/graphql/graphql-clients`'s
 * `createClientGraphQLClient()` (itself a thin adapter over
 * `@west-tennessee-consulting/supabase-graphql-kit`).
 *
 * This used to hand-roll its own `ApolloClient` with a token-caching
 * optimization (avoid `await supabase.auth.getSession()` on every GraphQL
 * operation). That optimization is real and now lives in
 * `createClientGraphQLClient()` itself, shared by every Hub caller instead
 * of just this one — see that function's own comments for the reasoning.
 *
 * Kept as a module-level singleton (not a factory call at each import site)
 * since this is the one export `lib/data.ts` actually consumes, matching
 * its pre-consolidation shape exactly.
 */
// Imported from the CLIENT-SAFE module, never from `graphql-clients`: this file
// is reached from `src/lib/providers.tsx` ("use client", every page), and
// `graphql-clients` pulls `node:async_hooks` via attribution-context — which
// failed every Hub build from 5a91bf430 until this split.
import { createClientGraphQLClient } from "@/lib/graphql/browser-graphql-client";

export const apolloClient = createClientGraphQLClient();
